import { useEffect } from "react";
import Footer from "../components/Footer";
import PublicNav from "../components/PublicNav";

const SECTIONS = [
  {
    title: "1. Who this applies to",
    content: `Joborigo is free for job seekers. There is nothing to pay and nothing to refund on a job seeker account.

This policy applies to paid agency and employer plans only.`,
  },
  {
    title: "2. Subscriptions",
    content: `Agency and employer plans are billed monthly or annually via Paddle, at the prices shown on our pricing page. Subscriptions renew automatically at the end of each billing period unless cancelled.

You may cancel at any time from your account settings. Cancellation takes effect at the end of your current billing period. You keep access until then and are not charged again.`,
  },
  {
    title: "3. Right of withdrawal",
    content: `If you are a consumer in the EU, you have a statutory right to withdraw from a paid subscription within 14 days of purchase, without giving a reason, under the Swedish Distance and Off-Premises Contracts Act (lag 2005:59).

If you expressly ask for the service to begin immediately and acknowledge that you thereby waive this right, the 14-day right does not apply once the service has started.

The statutory right of withdrawal does not apply to business customers. Most agency and employer plans are purchased by businesses.`,
  },
  {
    title: "4. Refunds outside the withdrawal period",
    content: `Outside the right of withdrawal described above, subscription payments are not refunded for partial billing periods, except where required by mandatory consumer protection law. This does not affect your statutory rights as a consumer.

Refunds are not issued for:

• Subscription renewals
• Partial months where the service was available and accessible
• Accounts found to be in violation of our Terms of Service

If something has gone genuinely wrong on our side, contact us. We would rather sort it out than hide behind a policy.`,
  },
  {
    title: "5. How to request a refund",
    content: `Contact us at support@joborigo.com with:

• Your registered email address
• The date of your purchase
• The reason for your request

We respond within 2 business days. Approved refunds are processed within 5 business days and returned to the original payment method.`,
  },
  {
    title: "6. Payment processing",
    content: `Payments are processed by Paddle.com Market Limited, our Merchant of Record. Paddle handles billing, tax collection and payment processing on our behalf. For billing disputes you may also contact Paddle directly at paddle.com/support.`,
  },
  {
    title: "7. Contact",
    content: `For any billing or refund question:

Email: support@joborigo.com
Response time: within 2 business days

Joborigo is operated by Stefan Asanin, trading as Joborigo (enskild firma), registered in Sweden.`,
  },
];

export default function RefundPolicy() {
  useEffect(() => {
    document.title = "Joborigo: Refund Policy";
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-brand-dark-bg text-gray-900 dark:text-gray-100">
      <PublicNav />

      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full">
        <div className="mb-12">
          <p className="text-sm font-medium text-brand-violet dark:text-brand-violet-on-dark mb-3 uppercase tracking-widest">
            Legal
          </p>
          <h1 className="text-4xl font-extrabold mb-4">Refund Policy</h1>
          <p className="text-gray-400 text-sm">
            Last updated: September 2026 · Effective immediately
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {SECTIONS.map((section) => (
            <section key={section.title}>
              <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-3">
                {section.title}
              </h2>
              <div className="text-gray-500 dark:text-gray-400 leading-relaxed whitespace-pre-line text-sm">
                {section.content}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-gray-100 dark:border-white/10">
          <p className="text-sm text-gray-400">
            Questions?{" "}
            <a
              href="mailto:support@joborigo.com"
              className="text-brand-violet dark:text-brand-violet-on-dark hover:underline"
            >
              support@joborigo.com
            </a>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
